import type { QueryResult } from '@apollo/react-common';
import { toIssueTypeId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ServiceQueryResult } from '@atlassian/jira-software-deployments-service-query-types/src/services/types.tsx';
import type { IssueType } from '../../common/types.tsx';
import type {
	jira_cycleTimeReport_projectIssueTypes_Query as ProjectQuery,
	jira_cycleTimeReport_projectIssueTypes_QueryVariables as ProjectQueryVariables,
	jira_cycleTimeReport_projectIssueTypes_Query_project as GraphQLProjectType,
	jira_cycleTimeReport_projectIssueTypes_Query_project_issueTypes as GraphQLIssueType,
} from './__generated_apollo__/jira_cycleTimeReport_projectIssueTypes_Query';

const transformIssueType = (issueType: GraphQLIssueType): IssueType => ({
	id: toIssueTypeId(issueType.id),
	name: issueType.name,
	iconUrl: issueType.iconUrl != null ? issueType.iconUrl : '',
});

const transformProject = (project: GraphQLProjectType): IssueType[] | Error => {
	const { issueTypes } = project;
	if (issueTypes == null || issueTypes.length === 0) {
		return Error('Issue types not found');
	}
	return issueTypes.map(transformIssueType);
};

export const transformQueryResult = ({
	loading,
	error,
	data,
}: QueryResult<ProjectQuery, ProjectQueryVariables>): ServiceQueryResult<IssueType[]> => {
	if (loading) {
		return {
			loading: true,
		};
	}
	if (error) {
		return {
			error,
			loading: false,
		};
	}

	if (data == null || data.project == null) {
		return {
			loading: false,
			error: Error('Project not found'),
		};
	}

	const transformationResult = transformProject(data.project);

	return transformationResult instanceof Error
		? {
				error: transformationResult,
				loading: false,
			}
		: {
				data: transformationResult,
				loading: false,
			};
};
